import React from 'react';
import { Outlet, useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { AdminMenu } from './AdminMenu';
import '../styles/Admin.css';

export function AdminLayout(): JSX.Element {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="admin-layout">
      <header className="admin-header">
        <div className="admin-header-content">
          <div className="admin-header-left">
            <h1 className="admin-title" onClick={() => navigate('/admin')}>
              Admin-Bereich
            </h1>
            <Link to="/dashboard" className="back-to-portal">
              Zum Portal
            </Link>
          </div>
          <div className="admin-header-right">
            <span className="admin-user">
              {user?.admin?.name}
              {user?.isSuperAdmin && <span className="super-badge">Super</span>}
            </span>
            <button className="logout-btn" onClick={handleLogout}>
              Abmelden
            </button>
          </div>
        </div>
        <AdminMenu />
      </header>
      <main className="admin-main">
        <Outlet />
      </main>
      <footer className="admin-footer">
        <p>&copy; {new Date().getFullYear()} Schulungsportal - Admin</p>
      </footer>
    </div>
  );
}

export default AdminLayout;
